export const BODEGA = {
    codigo: '68000',
    contenido: 'Cajas de Mezcal Artesanal',
    nombres: 'Reyna',
    apellidos: 'Aquino Pacheco',
    correo: 'info@generacionmezcal.com',
    calle: 'Manuel Doblado',
    numero: '802',
    barrio: 'Centro',
    celular: '9512528698',
    estado: 'Oaxaca',
    municipio: 'Oaxaca de Juárez',
    referencia: 'Esquina con Xóchitl',

}